/**
 * @ignore
 */
import * as React from 'react';
import cx from 'classnames';
import { triggerCallback } from '../clientApi';
import InnerHtml from '../components/InnerHtml';
import { Helmet } from '../components/meta';
import { BASE_CDN } from '../utils/config';
const ArticleBody = ({ className, articleId, html, noStyles, onClickInterlink, onClick, }) => {
    const onArticleClick = (e) => {
        onClick && onClick(e);
    };
    useInterlinkClick({ onClickInterlink, html });
    // Trigger the on('article:loaded') event.
    React.useEffect(() => {
        triggerCallback('article:load', {
            articleId,
            body: html,
        });
    }, [html, articleId]);
    return (React.createElement(React.Fragment, null,
        !noStyles && (React.createElement(Helmet, null,
            React.createElement("link", { rel: "stylesheet", type: "text/css", href: `${BASE_CDN}/article-styles/article-min.css` }))),
        React.createElement(InnerHtml, { className: cx('article', className), html: html, onClick: onArticleClick, "data-testid": "article-body" })));
};
ArticleBody.displayName = 'ArticleBody';
export default ArticleBody;
/** Add interlink event listeners */
function useInterlinkClick({ onClickInterlink, html, }) {
    React.useEffect(() => {
        function onclickArticle(event, elem) {
            const t = event.target;
            const dataset = (elem && elem.dataset) || (t && t.dataset);
            if (dataset.elevioArticle ||
                dataset.elevioInline ||
                dataset.elevioModule) {
                event.preventDefault();
                event.stopPropagation();
            }
            if (dataset.elevioArticle) {
                onClickInterlink && onClickInterlink(dataset.elevioArticle);
            }
        }
        const elems = document.querySelectorAll(`.article a, .article span[role='link'], .article [data-elevio-article]`);
        // Just so we can clean them up
        const listeners = [];
        for (let i = 0; i < elems.length; ++i) {
            const a = elems[i];
            listeners[i] = (ev) => onclickArticle(ev, a);
            a.addEventListener('click', listeners[i], false);
        }
        return () => {
            for (let i = 0; i < elems.length; ++i) {
                const a = elems[i];
                a.removeEventListener('click', listeners[i], false);
            }
        };
    }, [html, onClickInterlink]);
}
//# sourceMappingURL=articleBody.js.map